import type { BackendEntityType } from "./AttachmentModel";

export enum FBNotificationType {
	// Core
	PersonAcceptedConnectionRequest = "core/personAcceptedConnectionRequest",
	PersonConnectionRequest = "core/personConnectionRequest",
	NewWaiver = "core/newWaiver",

	// Soccer
	MatchNotReadyToBePlayed = "soccer/soccerLeagueManagerMatchNotReadyToPlay",
	ReforgAcceptedInvitationToCompetition = "soccer/refereeOrganizationAcceptedInvitationToCompetition",
	CoachAcceptedInvitationToClub = "soccer/coachAcceptedInvitationToClub",
	ManagerAcceptedInvitationToClub = "soccer/managerAcceptedInvitationToClub",
	ManagerAcceptedInvitationToTeam = "soccer/managerAcceptedInvitationToTeam",
	ManagerAcceptedInvitationToLeague = "soccer/managerAcceptedInvitationToLeague",
	ManagerAcceptedInvitationToFacility = "soccer/managerAcceptedInvitationToFacility",
	ManagerAcceptedInvitationToOrg = "soccer/managerAcceptedInvitationToOrg",
	RefereeAcceptedInvitationToOrg = "soccer/refereeAcceptedInvitationToOrg",
	PlayerAcceptedInvitationToClub = "soccer/playerAcceptedInvitationToClub",
	RefereePostMatchReportReminder = "soccer/refereePostMatchReportReminder",
	TeamsJoinedCompetition = "soccer/teamsJoinedCompetition",
	PaymentsOrderGenerated = "soccer/paymentOrderGenerated",

	// Posts
	postCommented = "posts/postCommented"
}

export interface FBNotification {
	triggeredAt: {
		seconds: number;
		nanoseconds: number;
	};
	type: FBNotificationType;
	subject: {
		type: BackendEntityType;
		id: string;
		params: any;
	};
	initiator?: {
		type: BackendEntityType;
		id: string;
		name: string;
		logo?: string;
	};
	message: {
		en: string;
	};
}
